export const RouteCategories_categoryId_PdfSummaryExclusions =
  "/categories/:categoryId/pdf-summary-exclusions";

export interface ParamsCategories_categoryId_PdfSummaryExclusions {
  categoryId: string;
}

export interface PayloadFormPostCategories_categoryId_PdfSummaryExclusions {
  file: File;
}

export interface ResponseGetCategories_categoryId_PdfSummaryExclusions {
  product_codes: string[];
}

export interface ResponsePostCategories_categoryId_PdfSummaryExclusions {
  product_count: number;
}
